<script>
  export let workouts

  import { createEventDispatcher } from 'svelte'

  import TimeAgo from 'javascript-time-ago'
  import en from 'javascript-time-ago/locale/en.json'
  TimeAgo.addDefaultLocale(en)
  const timeAgo = new TimeAgo('en-US')

  const dispatch = createEventDispatcher()

  function chooseWorkout(workout) {
    dispatch('chooseWorkout', workout)
  }
</script>

<div class="list-group">
  {#each workouts as workout (workout.id)}
    <button
      type="button"
      class="list-group-item list-group-item-action"
      on:click={() => chooseWorkout(workout)}
      >Resume Workout Started {timeAgo.format(
        Date.parse(workout.start)
      )}</button
    >
  {/each}
  <button
    type="button"
    class="list-group-item list-group-item-action active"
    on:click={() => {
      dispatch('startNewWorkout')
    }}>Start New Workout</button
  >
</div>
